// extracted by mini-css-extract-plugin
export default {"layout":"ChangePasswordPopup__layout--3M0","container":"ChangePasswordPopup__container--vqb"};